module.exports = __webpack_public_path__ + "static/emega-3daf91fb27326528145b6aba4bcb2b3d.png";